export default __webpack_public_path__ + "static/award4-5d46dd41a37d0bbe53c2a0b332499df7.png";